<app-breadcrumb></app-breadcrumb>
<section class="section min-vh-100 my-3">
    <div class="container py-0 mb-5">
        <div class="row">
            <div class="col-lg-3 mb-7 mb-lg-0">
                <div class="card card-shadow">
                    <div class="card-body p-0">
                        <ul class="nav flex-column nav-pills">
                            <li class="">
                                <a class="nav-link border-0 shadow-none rounded-0" [routerLink]="['/faq']"
                                    [routerLinkActiveOptions]="{exact:true}" routerLinkActive="active">All</a>
                            </li>
                            <li class="">
                                <a class="nav-link border-0 shadow-none rounded-0" *ngFor="let item of faqCategories"
                                    [routerLink]="['/faq']" [queryParams]="{faqCategoryId: item.id}"
                                    routerLinkActive="active">{{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9" id="basicsAccordion">

                <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
                    <ngb-panel *ngFor="let item of queryResult.items;let i = index" cardClass="rounded-0"
                        id="panel-{{item.id}}">
                        <ng-template ngbPanelHeader let-opened="opened">
                            <div (click)="acc.toggle('panel-' + item.id)" class="d-flex justify-content-between"
                                role="button">
                                <span>{{ item.question }}</span>
                                <span>
                                    <i class="material-icons">
                                        {{ opened ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                                    </i>
                                </span>
                            </div>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div [innerHtml]="item.answer">
                            </div>
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>

                <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page"
                    [page-size]="query.pageSize">
                </pagination>
            </div>
        </div>
    </div>
</section>